import { Card, CardContent } from '../../primitives/card';
import { DataTable, DataTableProps } from '../../primitives/data-table/data-table';

import { cn } from '../../utils/cn';
import { CardHeaderSimple, type CardHeaderBadge } from './card-header-simple';

import type { JSX } from 'react';

interface CardDataTableProps<TData, TValue> extends DataTableProps<TData, TValue> {
  header?: {
    action?: JSX.Element;
    badges?: CardHeaderBadge[];
    description?: string;
    icon?: JSX.Element;
    title: string | JSX.Element;
  };
}

export function CardDataTable<TData, TValue>({
  header,
  ...rest
}: CardDataTableProps<TData, TValue>) {
  return (
    <Card id={rest?.id}>
      {!header ? null : <CardHeaderSimple {...header} />}
      <CardContent className={cn({ 'pt-6': !header })}>
        <DataTable {...rest} />
      </CardContent>
    </Card>
  );
}
